type PaymentMethodIconProps = { children: React.ReactNode };

const PaymentMethodIcon = ({ children }: PaymentMethodIconProps) => {
	return <div className={`vtex-store-footer-2-x-paymentMethodIcon w2 h2 mh2 flex items-center`}>{children}</div>;
};

export default PaymentMethodIcon;
